// extracted by mini-css-extract-plugin
export default {"actions":"Pendientes_actions__jvgXP","download":"Pendientes_download__sfYtg","mes":"Pendientes_mes__wEW1d"};